import { usePostPortfolioCommoditiesMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioCommoditiesMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { COMMODITIES_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormDefaults";
import { getCommoditiesFormSchema } from "web_myplann/Portfolio/Forms/CommoditiesForm/commoditiesFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateCommoditiesForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioCommoditiesMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getCommoditiesFormSchema(t),
		defaultValues: COMMODITIES_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddCommoditiesSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
